// SPDX-FileCopyrightText: 2023 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
//import loadImageIntoElement from 'components/treactui-template/meta/loadImageIntoElement';
import { get } from '@tls/auth';
import { blobToBase64 } from 'components/treactui-template/meta/loadImageIntoElement';

export function resetMask(): void {
  document.body.dispatchEvent(new CustomEvent('resetmask', { bubbles: true }));
}

export function exportMask(): Promise<File | undefined> {
  return new Promise<File | undefined>(resolve => {
    const getMask = e => {
      const mask = e.detail;
      const dataUrl = mask?.dataUrl as string;
      const blob = base64ToBlob(dataUrl.split(',')[1]);
      const filename = 'mask.png';
      resolve(new File([blob], filename, { type: 'image/png' }));

      document.removeEventListener('maskexported', getMask);
    };

    document.addEventListener('maskexported', getMask);

    document.body.dispatchEvent(new CustomEvent('export', { detail: { format: 'png' }, bubbles: true }));
  });
}

type SetMaskOptions = {
  signal?: AbortSignal;
  imageId?: string;
};

export async function setMask(maskUrl: string, options: SetMaskOptions = {}): Promise<boolean> {
  try {
    const { data, status } = await get(maskUrl, false, false, {
      responseType: 'blob',
      signal: options.signal,
    });

    if (options.signal?.aborted || status < 200 || status >= 400 || !data) return false;

    const base64 = await blobToBase64(data);
    if (options.signal?.aborted) return false;

    document.body.dispatchEvent(
      new CustomEvent('maskimported', {
        detail: {
          imageData: base64,
          imageId: options.imageId,
          title: 'Image',
        },
        bubbles: true,
      })
    );
    return true;
  } catch {
    return false;
  }
}

export function undoMask() {
  document.body.dispatchEvent(
    new CustomEvent('undomask', {
      bubbles: true,
    })
  );
}

export function redoMask() {
  document.body.dispatchEvent(
    new CustomEvent('redomask', {
      bubbles: true,
    })
  );
}

function base64ToBlob(base64: string) {
  // use atob() to decode base64 encoded string
  const bin = atob(base64);

  const buffer = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) {
    buffer[i] = bin.charCodeAt(i);
  }
  const blob = new Blob([buffer.buffer], { type: 'image/png' });
  return blob;
}
